import React from 'react';

function SvgClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <defs />
      <path
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M19 5L5 19M19 19L5 5"
      />
    </svg>
  );
}
export default SvgClose;
